import { Box, Stack, Typography } from "@mui/material";
import { MOBILE_BREAKPOINT } from "@/styles/responsive";
import { TEXT } from "../utils/tokens";
import { ReassistMarkIcon } from "./ReassistMarkIcon";

interface Props {
  title: string;
  description: string;
  /** 操作のボタン。PC は見出しのまとまりの右側（下端そろえ）、SP は説明の下に置く。 */
  actions?: React.ReactNode;
}

/**
 * /reassist と /reassist/archive の見出し。1段目にマーク（ビルの図案）と h1、2段目に説明。
 * 文字入りのロゴは置かない（見出しの上に小さく置くと、見出しとの間が中途半端になるため）。
 */
export const ReassistPageHeader: React.FC<Props> = ({
  title,
  description,
  actions,
}) => (
  <Stack
    direction={{ xs: "column", [MOBILE_BREAKPOINT]: "row" }}
    sx={{
      gap: { xs: 2, [MOBILE_BREAKPOINT]: 3 },
      alignItems: { xs: "stretch", [MOBILE_BREAKPOINT]: "flex-end" },
      justifyContent: "space-between",
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      <Stack direction="row" sx={{ alignItems: "center", gap: 1.25 }}>
        <ReassistMarkIcon aria-hidden sx={{ fontSize: 28, flexShrink: 0 }} />
        <Typography
          component="h1"
          sx={{ ...TEXT.pageTitle, color: "text.primary" }}
        >
          {title}
        </Typography>
      </Stack>
      <Typography
        sx={{
          ...TEXT.body,
          mt: 1,
          maxWidth: 640,
          color: "text.secondary",
        }}
      >
        {description}
      </Typography>
    </Box>
    {actions !== undefined && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
  </Stack>
);
